import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.css']
})
export class GenericModalComponent {

  @Input()
  public modalTitle: string = "";

  @Input()
  public modalId: string = "";

  @Input()
  public modalSize: string = "modal-lg";

  @Input()
  public displayHeader: boolean = true;
}
